/**
 * Debounce function to limit the execution rate of a given function.
 */
export const debounce = (func: Function, wait: number) => {
    let timeout: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    };
};

/**
 * Waits for the UC_UI object to be available on the window.
 */
export const waitForUC_UI = async (): Promise<void> => {
    return new Promise((resolve) => {
        if (typeof window.UC_UI !== "undefined" && typeof window.UC_UI.getServicesFullInfo === "function") {
            resolve();
        } else {
            const checkInterval = setInterval(() => {
                if (typeof window.UC_UI !== "undefined" && typeof window.UC_UI.getServicesFullInfo === "function") {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100);
        }
    });
};

/**
 * Force re-render of iframes by removing and re-attaching them to the DOM.
 */
export const reRenderIframes = (iframes: NodeListOf<Element>) => {
    iframes.forEach((iframe) => {
        const parent = iframe.parentNode;
        if (parent) {
            const nextSibling = iframe.nextSibling;
            parent.removeChild(iframe);
            if (nextSibling) {
                parent.insertBefore(iframe, nextSibling);
            } else {
                parent.appendChild(iframe);
            }
        }
    });
};


/**
 * Applies block elements logic for a given service and triggers re-render for associated iframes.
 */
export const applyBlockElements = (service: { name: string; selector: string; serviceId: string }) => {
    const iframes = document.querySelectorAll(service.selector);
    if (iframes.length > 0) {
        if (typeof window.uc !== "undefined" && typeof window.uc.blockElements === "function") {
            window.uc.blockElements({
                [service.serviceId]: service.selector,
            });
            reRenderIframes(iframes);
        } else {
            console.error("Usercentrics blockElements function is not available.");
        }
    } else {
        console.warn(`No iframes found for service: "${service.name}"`);
    }
};

/**
 * Generates fallback consent for services when `getServicesConsentStatus` is unavailable.
 */
export const generateFallbackConsent = (
    services: { name: string }[]
): { [service: string]: boolean } => {
    return services.reduce((consentStatus, service) => {
        consentStatus[service.name] = false;
        return consentStatus;
    }, {} as { [service: string]: boolean });
};


